import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchStructureVersions} from './../actions';
import {FormattedMessage} from 'react-intl';
import Table from '../../ui/components/Table';
import dateHelper from '../../../helpers/dateHelper';
import Link from '../../routing/components/Link';
import {structureIndexRoute} from '../../../constants/public-routes';

class StructureVersions extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.props.fetchStructureVersions(this.props.params.structureId, 'date');
  }

  render() {
    let {lang, structureVersions, structureId} = this.props;
    let head = [null];
    let items = [];
    if (!structureVersions.item || structureVersions.item.length === 0) {
      items.push([<em key="noVersions"><FormattedMessage id="noVersions"/></em>]);
    }
    else {
      items = structureVersions.item.map((result, i) => {
        if (result.id === structureId) {
          return [<span
            key="currentVersion">{result.attributes.preview.label}: <FormattedMessage
            id="currentVersion"/></span>];
        }
        return [<Link key={result.id} url={structureIndexRoute(lang, result.id)}>{result.attributes.preview.label}</Link>];
      });
    }

    return (<Table head={head} items={items}/>);
  }
}

StructureVersions.propTypes = {
  structureVersions: PropTypes.object.isRequired,
  fetchStructureVersions: PropTypes.func.isRequired,
  structureId: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  params: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  const {structure, structureVersions} = state;
  let {lang, structureId} = ownProps.params;
  let myStructureVersions = JSON.parse(JSON.stringify(structureVersions));
  if (myStructureVersions.item) {
    let date = (structure.item && structure.item.attributes.date_version) ? structure.item.attributes.date_version : dateHelper.formatToApi(new Date(), 'X')
    myStructureVersions.item.push({
      id: structureId,
      attributes: {
        date: date,
        label: structure.item.attributes.version_comment ? structure.item.attributes.version_comment : dateHelper.formatDate(date, lang),
        preview: {
          label: structure.item.attributes.version_comment ? structure.item.attributes.version_comment : dateHelper.formatDate(date, lang)
        },
      }
    });
    myStructureVersions.item.sort((a, b) => {
      return b.attributes.date.localeCompare(a.attributes.date);
    });
  }
  return {
    structureId,
    structure,
    structureVersions: myStructureVersions,
    lang
  };
}

function mapDispatchToProps(dispatch) {
  return {fetchStructureVersions: bindActionCreators(fetchStructureVersions, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(StructureVersions);



/** WEBPACK FOOTER **
 ** ./src/modules/structures/components/StructureVersions.js
 **/